import { extend } from "flarum/common/extend";
import app from "flarum/app";
import LinkButton from "flarum/common/components/LinkButton";
import UserPage from "flarum/forum/components/UserPage";
import ProfessionalAchievementsPane from "../panes/PersonalSubscriptionsPane";

export default function () {
  app.routes["tolyod-advcomments-personal-subscriptions-view-profile"] = {
    path: "/user_subscriptions/:id",
    component: ProfessionalAchievementsPane,
  };
  extend(UserPage.prototype, "navItems", function (items) {
    const href = app.route(
      "tolyod-advcomments-personal-subscriptions-view-profile",
      {
        id: this.user.id(),
      }
    );
    items.add(
      "personal_subscriptions",
      LinkButton.component(
        {
          href,
          icon: "far fa-eye",
        },
        app.translator.trans("tolyod-advdiscus.forum.user_profile.personal_subscriptions")
      ),
      0
    );
  });
}
